"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emptyAddress = void 0;
exports.emptyAddress = {
    addressLine1: "",
    addressLine2: "",
    city: "",
    country: "ID",
    state: "",
    zip: "",
    isDefault: false,
};
//# sourceMappingURL=empty-address.js.map